import { useEffect } from 'react'

const PIXEL_ID = '4214137565465343'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export function useMetaPixel() {
  useEffect(() => {
    // Skip if already loaded
    if (window.fbq) return

    const n: any = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })

    if (!window._fbq) window._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    const t = document.createElement('script')
    t.async = true
    t.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(t)

    window.fbq('init', PIXEL_ID)
    window.fbq('track', 'PageView')
  }, [])
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'El Reinicio de 72 Horas',
      content_type: 'product',
      value: 11.99,
      currency: 'USD',
    })
  }
}
